export enum AuthStatusTypeEnum {
  SUCCESS = 'success',
  OTP_REQUIRED = 'otp_required',
  PASSWORD_REQUIRED = 'password_required',
  CREATED = 'created',
  INVALID_AUTH = 'invalid_auth',
  UNKNOWN_AUTH_TYPE = 'unknown_auth_type',
  USER_NOT_FOUND = 'user_not_found',
}

export enum AuthTypeEnum {
  OTP = 'otp',
  PASSWORD = 'password',
  OTP_AND_PASSWORD = 'otp_and_password',
}

export enum AuthStateEnum {
  IDLE = 'idle',
  VERIFICATION = 'verification',
  IS_VERIFIED = 'is_verified',
  FORGOT_PASSWORD = 'forgot_password',
  NEEDS_TO_CHANGE_PASSWORD = 'needs_to_change_password',
  CLOSE_REGISTRATION = 'close_registration',
}

export const AUTH_STATE = 'authState' as const;

// Login refusal for an email domain with no MX/A record; hydra-bridge and the legacy auth form map it to the form text.
export const EMAIL_DOMAIN_UNREACHABLE_ERROR_CODE = 'EMAIL_DOMAIN_UNREACHABLE';

export const AUTH_ACCESS_TOKEN = 'accessToken' as const;
export const AUTH_REFRESH_TOKEN = 'refreshToken' as const;
// One-time login code in the callback URL — the consumer exchanges it for the token pair.
export const AUTH_CODE = 'code' as const;
